import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import './index.scss'
import { AppUtil } from '../../../lib/app_util'

function mapStateToProps(state) {
  return {
    customer: state.customer,
    showHeader: state.common.showHeader
  }
}

function MobileHeaderContainer(props) {
  if (!props.customer.id) {
    return null
  }
  const navList = [
    {
      router: '/home', //跳转url
      activeUrl: ['/', '/home'], //高亮url
      text: '首页'
    },
    {
      router: '/totes',
      activeUrl: ['/totes'],
      text: '衣箱'
    },
    {
      router: '/account',
      activeUrl: ['/account'],
      text: '我的'
    }
  ]

  const handleClick = href => () => props.router.replace(href)

  const getIcons = (path, active) => {
    return require(`./images${path}${active ? '_select' : ''}.svg`)
  }

  const { location, showHeader } = props

  const isPhoneX = AppUtil.isPhoneX()

  return (
    <div
      className={`header-nav-bar ${showHeader ? '' : 'hidden'} ${
        isPhoneX ? 'isPhoneX' : ''
      }`}
    >
      {_.map(navList, ({ activeUrl, router, text }, k) => {
        const selected = _.includes(activeUrl, location.pathname)
        return (
          <span
            className={`nav-link ${selected ? 'selected' : ''}`}
            onClick={handleClick(router)}
            key={k}
          >
            <div className="icon">
              <img src={getIcons(router, selected)} alt="imgs" />
            </div>
            {text}
          </span>
        )
      })}
    </div>
  )
}

export default connect(mapStateToProps)(withRouter(MobileHeaderContainer))
